import * as React from "react";
import { Header } from '@graffer-inc/graffer-ui';

export const MaintenancePage = () => {
  const html =
    process.env.REACT_APP_MAINTENANCE_MESSAGE || "只今メンテナンス中です";
  return (
    <>
      <Header
          fixed
          serviceName="電子証明書取得サポート"
      />
      <main>
        <section className="hero is-fullheight">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-centered">
                <div className="column">
                  <h1
                    className="title is-size-5 has-text-centered"
                    data-testid="name"
                    dangerouslySetInnerHTML={{ __html: html }}
                  ></h1>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
